<div>
	<div>
		<div class="title" (click)="handleClick()">
			<div>{{data.title}}</div>
			<div>{{IsTrue ? '-':'+'}}</div>
		</div>
		<div *ngIf="IsTrue" class="description">{{data.description}}</div>
	</div>
</div>